import { createApi } from "@reduxjs/toolkit/query/react";
import { customBaseQuery } from "../../common/reduxQuery/helpers";
import {
  ExternalDataViewDto,
  ExternalDataQueryParams,
  ExternalDataRecordsResponse,
} from "../interfaces/externalDataView";

export const externalDataApi = createApi({
  reducerPath: "externalDataApi",
  baseQuery: customBaseQuery(),
  endpoints: (build) => ({
    getViewsForOrganization: build.query<ExternalDataViewDto[], string>({
      query: (organizationId) => ({
        url: `/api/v1/external-data-views/${organizationId}`,
        method: "GET",
      }),
    }),
    getViewConfiguration: build.query<
      ExternalDataViewDto,
      {
        organizationId: string;
        schema: string;
        categorizationId: string | null;
      }
    >({
      query: ({ organizationId, schema, categorizationId }) => ({
        url: `/api/v1/external-data-views/${organizationId}/${encodeURIComponent(
          schema,
        )}`,
        method: "GET",
        params: categorizationId ? { categorizationId } : undefined,
      }),
    }),
    queryExternalData: build.query<
      ExternalDataRecordsResponse,
      ExternalDataQueryParams
    >({
      query: ({ organizationId, schema, categorizationId, query }) => ({
        url: `/api/v1/external-data-views/${organizationId}/${encodeURIComponent(
          schema,
        )}/query`,
        method: "POST",
        params: categorizationId ? { categorizationId } : undefined,
        body: query ?? {},
      }),
    }),
  }),
});

export const {
  useGetViewsForOrganizationQuery,
  useGetViewConfigurationQuery,
  useLazyQueryExternalDataQuery,
} = externalDataApi;
